import { useEffect, useReducer } from 'react'
import PremiumInsightsContext from './Context'
import { INITIAL_STATE, reducer } from './reducer'
import { useGuarenteedScid } from 'common/use-scid'
import getCollegePremiumInsights from './getCollegePremiumInsights'

const PremiumInsightsProvider = ({ children }: { children: React.ReactNode }) => {
  const scid = useGuarenteedScid()
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)

  useEffect(() => {
    getCollegePremiumInsights({
      scid,
      audience: state.selectedFilters.audience,
      bucket: state.selectedFilters.bucket,
      dispatch,
    })
  }, [scid, state.selectedFilters.audience, state.selectedFilters.bucket, dispatch])

  return (
    <PremiumInsightsContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </PremiumInsightsContext.Provider>
  )
}

export default PremiumInsightsProvider
